import { createNamespacedHelpers } from "vuex";
import notesModal from "./notesModal/notesModal.vue";
import { PlusSquareIcon } from "vue-feather-icons";
import { createTooltipContent } from "@/utils";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	{ mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	props: { cardData: Object },

	components: {
		notesModal,
		PlusSquareIcon,
	},

	data() {
		return {
			dows: [
				this.$t("days.monday"),
				this.$t("days.tuesday"),
				this.$t("days.wednesday"),
				this.$t("days.thursday"),
				this.$t("days.friday"),
				this.$t("days.saturday"),
				this.$t("days.sunday"),
			],
			sources: [
				"N/A",
				"N/A",
				"N/A",
				this.$t("toggle_legend.production"),
				this.$t("toggle_legend.preparation"),
				this.$t("toggle_legend.plate"),
			],
			showNotesModal: false,
		};
	},

	methods: {
		handleSaveNote,
		createTooltipContent,
	},

	computed: {
		...brandingGetters(["colors"]),

		...userGetters(["activeOutlet"]),
	},
};

async function handleSaveNote(note) {
	try {
		await this.$api.setTrackedLabelNote({
			labelId: this.cardData.label_id,
			note: note,
		});
		this.$emit("updateNote", note);
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}
